interface PdfResponse {
  content: string; // base64 or URL
  error?: string;
}

export async function generatePdf(html: string, filename: string): Promise<boolean> {
  try {
    const response = await fetch('https://36upemz6rav7lvv6p2uvv5ohr40emvxt.lambda-url.eu-west-1.on.aws/', {
      method: 'POST',
      body: JSON.stringify({ html, filename }),
    });
    const base64: PdfResponse = await response.json();

    if (base64.error || !base64.content) {
      console.error("PDF generation failed:", base64.error);
      alert("Failed to generate PDF. Please try again.");
      return false;
    }

    window.open(base64.content, '_blank');
    return true;
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert("Failed to generate PDF. Please try again.");
    return false;
  }
}